// Bar Chart Maker
function createGraph(data, container) {
    // Declare some common variables and container elements
    var bars = [];
    var figureContainer = $('<div class="bar-chart-figure"></div>');
    var graphContainer = $('<div class="bar-chart-graph"></div>');
    var barContainer = $('<div class="bar-chart-bars"></div>');
    var data = $(data);
    var container = container;
    var chartData;
    var chartYMax;
    var columnGroups;

    // Timer variables
    var barTimer;
    var graphTimer;

    // Create table data object
    var tableData = {
        // Get numerical data from table cells
        chartData: function () {
            var chartData = [];
            container.find('.js-bar-chart-info div').each(function () {
                chartData.push($(this).text());
            });
            return chartData;
        },
        // Get heading data from table caption
        chartHeading: function () {
            var chartHeading = data.find('caption').text();
            return chartHeading;
        },
        // Get legend data from table body
        chartLegend: function () {
            var chartLegend = [];
            // Find th elements in table body - that will tell us what items go in the main legend
            data.find('tbody th').each(function () {
                chartLegend.push($(this).text());
            });
            return chartLegend;
        },
        // Get highest value for y-axis scale
        chartYMax: function () {
            var chartData = this.chartData();
            // Round off the value
            var chartYMax = Math.ceil(Math.max.apply(Math, chartData) / 100) * 100;
            return chartYMax;
        },
        // Get y-axis data from table cells
        yLegend: function () {
            var chartYMax = this.chartYMax();
            var yLegend = [];
            // Number of divisions on the y-axis
            var yAxisMarkings = 5;
            // Add required number of y-axis markings in order from 0 - max
            for (var i = 0; i < yAxisMarkings; i++) {
                yLegend.unshift(((chartYMax * i) / (yAxisMarkings - 1)));
            }
            return yLegend;
        },
        // Get x-axis data from table header
        xLegend: function () {
            var xLegend = [];
            // Find th elements in table header - that will tell us what items go in the x-axis legend
            container.find('.js-bar-chart-axis div').each(function () {
                xLegend.push($(this).text());
            });
            return xLegend;
        },
        columnGroups: function () {
            var columnGroups = [];
            var columns = container.find('.js-bar-chart-info div').length;


            for (var i = 0; i < columns; i++) {
                columnGroups[i] = [];

                container.find('.js-bar-chart-info').each(function () {
                    var el = $(this).find('div');

                    columnGroups[i].push({
                        label: el.eq(i).text() ? el.eq(i).text() : 0,
                        value: el.eq(i).data('caption') ? el.eq(i).data('caption') : ''
                    });
                });
            }

            return columnGroups;
        }
    }

    // Useful variables for accessing table data
    chartData = tableData.chartData();
    chartYMax = tableData.chartYMax();
    columnGroups = tableData.columnGroups();

    // Loop through column groups, adding bars as we go
    $.each(columnGroups, function (i) {
        // Create bar group container
        var barGroup = $('<div class="bar-chart-group"></div>');
        // Add bars inside each column
        for (var j = 0, k = columnGroups[i].length; j < k; j++) {
            // Create bar object to store properties (label, height, code etc.) and add it to array
            // Set the height later in displayGraph() to allow for left-to-right sequential display
            var barObj = {};
            barObj.label = this[j].label;
            barObj.value = this[j].value;
            barObj.height = Math.floor(barObj.label / chartYMax * 100) + '%';

            var label = '<span class="bar-chart-label">' + this[j].label + '%</span>';
            var value = '<span class="bar-chart-value" title="' + this[j].value + '">' + this[j].value + '</span>';

            barObj.bar = $('<div class="bar-chart-item js-bar-chart-item"><div class="bar-chart-caption">' + label + value + '</div></div>')
                .appendTo(barGroup);
            bars.push(barObj);
        }
        // Add bar groups to graph
        barGroup.appendTo(barContainer);
    });

    // Add heading to graph
    var chartHeading = tableData.chartHeading();
    var heading = $('<h4>' + chartHeading + '</h4>');
    heading.appendTo(figureContainer);

    // Add x-axis to graph
    var xLegend = tableData.xLegend();
    var xAxisList = $('<ul class="bar-chart-x-axis"></ul>');
    $.each(xLegend, function (i) {
        var listItem = $('<li title="' + this + '"><span>' + this + '</span></li>')
            .appendTo(xAxisList);
    });
    xAxisList.appendTo(graphContainer);

    // Add y-axis to graph
    var yLegend = tableData.yLegend();
    var yAxisList = $('<ul class="bar-chart-y-axis"></ul>');
    $.each(yLegend, function (i) {
        var listItem = $('<li><span>' + this + '%</span></li>')
            .appendTo(yAxisList);
    });
    yAxisList.appendTo(graphContainer);

    // Add bars to graph
    barContainer.appendTo(graphContainer);

    // Add graph to graph container
    graphContainer.appendTo(figureContainer);

    // Add graph container to main container
    figureContainer.appendTo(container);

    // Set individual height of bars
    function displayGraph(bars, i) {
        // Changed the way we loop because of issues with $.each not resetting properly
        if (i < bars.length) {
            // Animate height using jQuery animate() function
            $(bars[i].bar).animate({
                height: bars[i].height
            }, 800);
            // Wait the specified time then run the displayGraph() function again for the next bar
            barTimer = setTimeout(function () {
                i++;
                displayGraph(bars, i);
            }, 100);
        }
    }

    // Reset graph settings and prepare for display
    function resetGraph() {
        // Stop all animations and set bar height to 0
        $.each(bars, function (i) {
            $(bars[i].bar).stop().css('height', 0);
        });

        // Clear timers
        clearTimeout(barTimer);
        clearTimeout(graphTimer);

        // Restart timer
        graphTimer = setTimeout(function () {
            displayGraph(bars, 0);
        }, 200);
    }

    // Call resetGraph() when button is clicked to start graph over
    $('.js-reset-graph').on('click', function () {
        resetGraph();

        return false;
    });

    // Finally, display graph via reset function
    resetGraph();
}


// Bar Colorizer
function colorizeBars() {
    $('.js-bar-chart-item').each(function () {
        var $container = $(this).closest('.js-bar-chart');

        $(this).css({
            backgroundColor: $container.data('background')
        });
    });
}


// Init
$(function () {
    var isBarChartExists = $('.js-bar-chart').data('exists');

    if (isBarChartExists) {
        $('.js-bar-chart').each(function () {
            createGraph('.js-bar-chart-table', $(this));
            colorizeBars();
        });

        setTimeout(function () {
            $('.bar-chart-caption').each(function () {
                $(this).fadeTo(400, 1);
            });
        }, 800);
    }
});

